import React from 'react';

import cokieImage from './icon-cookie.svg';
import './index.scss';
import './details.scss';
import MolLink from '../Menu/MolLink';
import $ from 'jquery';

interface CookieManagerProps {
  cookieDomain: string;
  cookieName: string;
  cookieData?: CookieItem[];
  domainPrefix: string;
}

export interface CookieItem {
  id: string;
  name: string;
  url: string;
  desciption: string;
  companyName: string;
  address1: string;
  address2: string;
  plz_city: string;
  country: string;
  saveDataNoEU: boolean;
  category: CookieItemCategory[];
  function: string;
  cookie: {
    name: string;
    exampleValue: string;
    duration: string;
    type: string;
    domain: string;
  }[];
  canDisabled?: boolean;
}
enum CookieItemCategory {}

interface CookieManagerState {
  show: boolean;
  showDetails: boolean;
  currentFunc: string;
  cookieTextArray?: string[];
  cookieData?: CookieItem[];
}

export const CustommerTypeCookieName = 'buchbutler_cm';

export default class CookieManager extends React.Component<
  CookieManagerProps,
  CookieManagerState
> {
  activateInterval: number | undefined;
  constructor(props: CookieManagerProps) {
    super(props);

    this.state = {
      show: false,
      showDetails: false,
      currentFunc: 'Funktion',
      cookieData: props.cookieData,
    };
  }

  componentDidMount() {
    let cookie = getCookie(this.props.cookieName);

    let newState = cookie == '';

    if (this.state.show != newState) this.showBanner(newState);

    this.setState({ cookieTextArray: this.getCookieArray() });

    let mywindow: any = window;

    mywindow.historyHelper.cookieBaner = this;

    if (this.state.cookieData == undefined) {
      let url = this.props.domainPrefix + '/frame/Api/Cookie.json';
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          this.setState({ cookieData: data });
        });
    }

    this.activateInterval = setInterval(() => {
      this.activateSnipped();
    }, 1000);
  }

  getCookieArray() {
    let cookieText = getCookie(this.props.cookieName);
    let acceptArray = cookieText.split('_');
    return acceptArray;
  }

  componentWillUnmount() {
    if (this.activateInterval != undefined) {
      clearInterval(this.activateInterval);
      this.activateInterval = undefined;
    }
  }

  showBannerIntern(show: boolean) {
    this.setState({ show: show });
  }

  showBanner(show: boolean) {
    this.showBannerIntern(show);
  }

  activateSnipped() {
    let items = $('[data-cmp-src]:not([data-cmp-done])');

    for (let i = 0; i < items.length; i++) {
      let vendor = items[i].getAttribute('data-cmp-vendor');
      if (
        this.state.cookieTextArray != undefined &&
        vendor != null &&
        this.state.cookieTextArray.includes(vendor)
      ) {
        let srcUrl = items[i].getAttribute('data-cmp-src');

        if (srcUrl != null) items[i].setAttribute('src', srcUrl);
        items[i].setAttribute('data-cmp-done', '1');
      }
    }
  }

  render() {
    let cookieData = this.state.cookieData;

    if (!this.state.show) {
      return (
        <div id="CookieManagerContainer">
          <div
            style={{ position: 'absolute', bottom: '0px', cursor: 'pointer' }}
          >
            <img
              style={{ width: '20px', height: '20px' }}
              width="20"
              height="20"
              alt="Datenschutz-Einstellungen"
              title="Datenschutz-Einstellungen"
              src={cokieImage}
              onClick={() => {
                this.setState({ show: true });
              }}
            />
          </div>
        </div>
      );
    }

    return (
      <div id="CookieManagerContainer">
        <div id="CookieManager">
          {!this.state.showDetails ? this.firstPageMol() : this.detailsPage()}
        </div>
      </div>
    );
  }

  firstPageMol() {
    let cookieData = this.state.cookieData;

    return (
      <div style={{ position: 'relative' }} id="firstBanner">
        <div className="textContainer">
          <b>Einwilligung zu Cookies & Daten</b>
          <p>
            Auf dieser Website nutzen wir Cookies und vergleichbare Funktionen
            zur Verarbeitung von Endgeräteinformationen und personenbezogenen
            Daten. Die Verarbeitung dient der Einbindung von Inhalten, externen
            Diensten und Elementen Dritter, der statistischen Analyse/Messung,
            personalisierten Werbung sowie der Einbindung sozialer Medien. Je
            nach Funktion werden dabei Daten an Dritte weitergegeben und von
            diesen verarbeitet.
            <br />
          </p>

          <br style={{ clear: 'both' }} />
          <br />
          <div style={{ marginTop: '10px', margin: 'auto' }}>
            <div
              style={{
                margin: 'auto',
                width: '100%',
                backgroundColor: 'rgb(90, 177, 75)',
                textAlign: 'center',
                padding: '8px',
                fontWeight: 'bold',
              }}
              onClick={() => {
                let resultAccept: string[] = [];
                for (
                  let i = 0;
                  cookieData != undefined && i < cookieData.length;
                  i++
                ) {
                  resultAccept = this.updateActivStatus(
                    resultAccept,
                    cookieData[i].id,
                    true,
                  );
                }
                this.saveCookie(resultAccept);
                this.setState({ show: false });
              }}
            >
              Alle akzeptieren
            </div>
            <br />

            <button
              style={{ margin: 'auto', width: '100%' }}
              onClick={() => {
                this.setState({ showDetails: true });
              }}
            >
              Erweiterte Einstellungen
            </button>
            <br />
            <br />
            <div className="links">
              <a href="/index.php?main_page=impressum&showCookieBanner=false">
                Impressum
              </a>

              <a href="/index.php?main_page=conditions&showCookieBanner=false">
                AGB
              </a>
              <a href="/index.php?main_page=privacy&showCookieBanner=false">
                Datenschutz
              </a>
              <a
                href="/index.php?main_page=widerrufsformular"
                className="widerruf-cookie-btn"
              >
                Widerruf einlegen
              </a>
              {/*
              <MolLink
                to="/impressum?showCookieBanner=false"
                href="/impressum?showCookieBanner=false"
              >
                Impressum
              </MolLink>

              <MolLink
                to="/agb?showCookieBanner=false"
                href="/agb?showCookieBanner=false"
              >
                AGB
              </MolLink>
              <MolLink
                to="/datenschutz?showCookieBanner=false"
                href="/datenschutz?showCookieBanner=false"
              >
                Datenschutz
              </MolLink>
              */}
            </div>
          </div>
        </div>
      </div>
    );
  }

  firstPage() {
    return (
      <div style={{ position: 'relative' }}>
        <div className="textContainer">
          <b>Einwilligung zu Cookies & Daten</b>
          <p>
            Auf dieser Website nutzen wir Cookies und vergleichbare Funktionen
            zur Verarbeitung von Endgeräteinformationen und personenbezogenen
            Daten. Die Verarbeitung dient der Einbindung von Inhalten, externen
            Diensten und Elementen Dritter, der statistischen Analyse/Messung,
            personalisierten Werbung sowie der Einbindung sozialer Medien. Je
            nach Funktion werden dabei Daten an Dritte weitergegeben und von
            diesen verarbeitet. Diese Einwilligung ist freiwillig, für die
            Nutzung unserer Website nicht erforderlich und kann jederzeit über
            das Icon links unten widerrufen werden.
            <br />
            <br />
            Um Ihnen als Kunden die richtigen Konditionen darstellen zu können,
            wählen Sie bitte beim jeweiligen Kästchen Ihre Zustimmung aus.
          </p>
          <div className="option">
            <span>Privat Kunde</span>
            <br />
            <button
              onClick={() => {
                let mywindow: any = window;

                let historyHelperModule: any = mywindow.historyHelper;
                let subAddress = historyHelperModule.browser.location;
                let targetUrl =
                  'https://www.moluna.de' +
                  subAddress.pathname +
                  subAddress.search;
                historyHelperModule.memory.push('/extern', targetUrl);
              }}
            >
              Akzeptieren
            </button>
          </div>
          <div className="option">
            <span>Buchhändler</span>
            <br />
            <button
              onClick={() => {
                setCookie(
                  CustommerTypeCookieName,
                  2,
                  90,
                  this.props.cookieDomain,
                );
                window.location.reload();
              }}
            >
              Akzeptieren
            </button>
            <br />
            <button
              onClick={() => {
                this.setState({ showDetails: true });
              }}
            >
              Anpassen
            </button>
          </div>
          <div className="option">
            <span>Firmenkunde/Behörde</span>
            <br />
            <button
              onClick={() => {
                setCookie(
                  CustommerTypeCookieName,
                  1,
                  90,
                  this.props.cookieDomain,
                );
                window.location.reload();
              }}
            >
              Akzeptieren
            </button>
          </div>
          <br style={{ clear: 'both' }} />
          <br />
          <div style={{ marginTop: '10px', margin: 'auto' }}>
            <button
              style={{ margin: 'auto', width: '100%' }}
              onClick={() => {
                this.setState({ show: false });
              }}
            >
              Ablehnen
            </button>
          </div>
        </div>
      </div>
    );
  }

  saveCookie(newAcceptArray: string[]) {
    let acceptLine = '__' + newAcceptArray.join('_');

    setCookie(this.props.cookieName, acceptLine, 90, this.props.cookieDomain);
    this.setState({ cookieTextArray: newAcceptArray });
  }

  updateActivStatus(acceptArraytmp: string[], id: string, newStatus: boolean) {
    let activ = acceptArraytmp.includes(id);

    if (newStatus == activ) {
      //alles gut
    } else if (newStatus && !activ) {
      acceptArraytmp.push(id);
    } else if (!newStatus && activ) {
      acceptArraytmp = acceptArraytmp.filter((value) => {
        if (value == '') return false;
        if (value != id) return true;
        return false;
      });
    }

    return acceptArraytmp;
  }

  detailsPage() {
    let cookieData = this.state.cookieData;

    let kategorie: CookieItem[][] = [];
    for (let i = 0; cookieData != undefined && i < cookieData.length; i++) {
      let cookieFunction = cookieData[i].function;
      if (cookieFunction == undefined) debugger;

      if (kategorie[cookieFunction] == undefined)
        kategorie[cookieFunction] = [];

      kategorie[cookieFunction].push(cookieData[i]);
    }

    let crateCat = (functionName, currentFunc) => {
      let classPostfix = '';
      if (functionName == currentFunc) classPostfix = ' aktiv';
      return (
        <div
          className={'funcButon' + classPostfix}
          onClick={(e) => {
            let myCat = functionName;
            this.setState({ currentFunc: myCat });
          }}
        >
          {functionName}
        </div>
      );
    };

    let getChoice = (settings: {
      activ: boolean | undefined;
      canDisabled: boolean;
      changeHandler: () => void;
    }) => {
      return (
        <div
          className="choiseBox"
          onClick={(ev) => {
            settings.changeHandler();
          }}
        >
          <div className="label">
            {settings.activ == true || settings.activ == undefined
              ? 'Aktiv'
              : 'Inaktiv'}
          </div>
          <span>
            <svg viewBox="0 0 20 10" className="symbol">
              {settings.activ == true ? (
                settings.canDisabled ? (
                  <path
                    fill="#5ab14b"
                    d="M 15,0 H 5 A 5,5 0 0 0 5,10 H 15 A 5,5 0 0 0 15,0 Z m -1,9 a 4,4 0 1 1 4,-4 4,4 0 0 1 -4,4 z"
                  />
                ) : (
                  <path
                    fill="#777777"
                    d="M 15,0 H 5 A 5,5 0 0 0 5,10 H 15 A 5,5 0 0 0 15,0 Z m -1,9 a 4,4 0 1 1 4,-4 4,4 0 0 1 -4,4 z"
                  />
                )
              ) : settings.activ == undefined ? (
                <path
                  fill="#777777"
                  d="M 14.999998,0 H 4.9999978 c -6.6666637,0 -6.6666637,10 0,10 H 14.999998 c 2.761426,0 4.999998,-2.2385763 4.999998,-5 0,-2.7614237 -2.238572,-5 -4.999998,-5 z M 9.9999978,9 C 6.4361306,9 4.6519851,4.6914458 7.1717144,2.1717166 9.6914438,-0.34801267 13.999998,1.4361328 13.999998,5 c 0,2.209139 -1.790861,4 -4.0000002,4 z"
                />
              ) : (
                <path
                  fill="#f64c4e"
                  d="M 15,0 H 5 A 5,5 0 0 0 5,10 H 15 A 5,5 0 0 0 15,0 Z M 6,9 A 4,4 0 1 1 10,5 4,4 0 0 1 6,9 Z"
                />
              )}
            </svg>
          </span>
        </div>
      );
    };

    let getChoiceRow = (settings: {
      label: JSX.Element;
      index: string;
      choiceSettings: {
        activ: boolean | undefined;
        canDisabled: boolean;
        changeHandler: () => void;
      };
    }) => {
      let key = 'row_' + settings.index;
      return (
        <tr key={key} id={key}>
          <td scope="row">{settings.label}</td>
          <td className="cmptdchoice">{getChoice(settings.choiceSettings)}</td>
        </tr>
      );
    };

    let detailsPanel = (functionName) => {
      let acceptArray = this.state.cookieTextArray ?? [];

      let functionStatus: boolean | undefined | null = null;

      kategorie[functionName].map((item, index) => {
        let activ = acceptArray.includes(item.id);
        if (functionStatus === null) functionStatus = activ;
        else {
          if (activ != functionStatus) functionStatus = undefined;
        }
      });

      if (functionStatus === null) functionStatus = true;

      let changeHandlerKategory = () => {
        let newStatus = true;
        if (functionStatus == true) newStatus = false;

        let resultAccept = acceptArray;
        kategorie[functionName].map((item, index) => {
          let newStatusTmp = newStatus;
          if (item.canDisabled === false) {
            newStatusTmp = true;
          }
          resultAccept = this.updateActivStatus(
            resultAccept,
            item.id,
            newStatusTmp,
          );
        });
        this.saveCookie(resultAccept);
      };

      let getChoiceKategorySetting = {
        activ: functionStatus,
        canDisabled: true,
        changeHandler: changeHandlerKategory,
      };

      return (
        <>
          <div className="catName">{this.state.currentFunc}</div>
          <div className="switchTableContainer">
            <table>
              <thead>
                <tr>
                  <th
                    className="cmpallprps cmptxt_purpose"
                    scope="col"
                    id="cmpboxlabelprps1"
                  >
                    Zweck
                  </th>
                  <th
                    className="cmpallprps cmpcenter cmptxt_all_purposes"
                    scope="col"
                  >
                    {' '}
                  </th>
                </tr>
              </thead>
              <tbody>
                {getChoiceRow({
                  label: functionName,
                  choiceSettings: getChoiceKategorySetting,
                  index: 'Kategory',
                })}
                <tr key="Kategory_space" id="Kategory_space">
                  <td colSpan={2}></td>
                </tr>
                <tr key="Anbieter" id="Anbieter">
                  <th>Anbieter</th>
                  <th>{getChoice(getChoiceKategorySetting)}</th>
                </tr>
                {kategorie[functionName].map((item, index) => {
                  let imageName = item.id;

                  if (item.id.startsWith('s')) {
                    imageName = 'v' + item.id.substring(1);
                  }

                  let activ = acceptArray.includes(item.id);

                  if (item.canDisabled === false) activ = true;

                  let changeHandler = () => {
                    let resultAccept = this.updateActivStatus(
                      acceptArray,
                      item.id,
                      !activ,
                    );

                    this.saveCookie(resultAccept);
                  };

                  return (
                    <>
                      {getChoiceRow({
                        label: (
                          <>
                            <span>{item.name}</span>
                            <a href="#">
                              <svg viewBox="0 0 24 24" width="16" height="16">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92c-.5.51-.86.97-1.04 1.69-.08.32-.13.68-.13 1.14h-2v-.5c0-.46.08-.9.22-1.31.2-.58.53-1.1.95-1.52l1.24-1.26c.46-.44.68-1.1.55-1.8-.13-.72-.69-1.33-1.39-1.53-1.11-.31-2.14.32-2.47 1.27-.12.37-.43.65-.82.65h-.3C8.4 9 8 8.44 8.16 7.88c.43-1.47 1.68-2.59 3.23-2.83 1.52-.24 2.97.55 3.87 1.8 1.18 1.63.83 3.38-.19 4.4z"></path>
                              </svg>
                            </a>
                          </>
                        ),
                        index: 'loop' + index,
                        choiceSettings: {
                          activ: activ,
                          canDisabled: item.canDisabled !== false,
                          changeHandler: changeHandler,
                        },
                      })}
                      <tr
                        key={'loop' + index + '_space'}
                        id={'loop' + index + '_space'}
                      >
                        <td colSpan={2}></td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      );
    };

    return (
      <div id="detailsPage">
        <div id="detailsPageWraper">
          <div className="menu">
            {crateCat('Funktion', this.state.currentFunc)}
            {crateCat('Marketing', this.state.currentFunc)}
            {crateCat('Messung', this.state.currentFunc)}
            {crateCat('Andere', this.state.currentFunc)}
          </div>
          <div className="detailsBox">
            <h1 className="headerCaption">Erweiterte Einstellungen</h1>
            <div className="headerText">
              Auf dieser Seite können Sie Informationen zu den Zwecken und
              Anbietern erfahren, die personenbezogene Daten auf unserer
              Webseite verarbeiten.
            </div>
            {detailsPanel(this.state.currentFunc)}
          </div>
        </div>
        <div>
          <div
            className="btn_save"
            onClick={() => {
              this.setState({ showDetails: false, show: false });
            }}
          >
            <svg viewBox="0 0 32 32">
              <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"></path>
            </svg>
            Speichern + Beenden
          </div>
        </div>
      </div>
    );
  }
}

export function setCookie(cname, cvalue, exdays, domain) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  let cookieText =
    cname + '=' + cvalue + ';' + expires + ';domain=' + domain + ';path=/';

  document.cookie = cookieText;
}

export function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export enum ConsentEnum {
  GoogleAnalytics = 'GoogleAnalytics',
  FB_pixel = 'FB_pixel',
  Webgains = 'Webgains',
  SENTRY = 'SENTRY',
}

export function hasConsent(name: ConsentEnum): boolean {
  //TODO: Implement COOKIE/Consens Logic
  if (name == ConsentEnum.SENTRY) return true;
  return false;
}
